// extracted by mini-css-extract-plugin
export var container = "_ad-0";